<template>
  <div class="page-padding">
    <!-- 密码验证层 -->
    <div v-if="!isAuthenticated" class="auth-overlay">
      <el-card class="auth-card">
        <h3>烟花管理系统</h3>
        <p>请输入管理密码</p>
        <el-input 
          v-model="password" 
          type="password" 
          placeholder="请输入密码"
          @keyup.enter.native="verifyPassword"
          style="margin-bottom: 15px;"
        ></el-input>
        <el-button type="primary" @click="verifyPassword" style="width: 100%;">登录</el-button>
      </el-card>
    </div>

    <!-- 管理内容 -->
    <el-card v-else>
      <!-- 店铺信息编辑 -->
      <div class="shop-info-section">
        <h3>店铺信息</h3>
        <el-form :inline="true" :model="shopInfo" size="small">
          <el-form-item label="店铺名称">
            <el-input v-model="shopInfo.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="shopInfo.description" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="shopInfo.address" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="电话1">
            <el-input v-model="shopInfo.phone1" style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="电话2">
            <el-input v-model="shopInfo.phone2" style="width: 150px"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <el-divider></el-divider>

      <!-- 操作按钮 -->
      <div class="action-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增产品</el-button>
        <el-button type="success" icon="el-icon-download" @click="exportJson">导出JSON</el-button>
        <el-button type="warning" icon="el-icon-upload2" @click="importDialogVisible = true">导入JSON</el-button>
        <el-select v-model="filterCategory" placeholder="筛选分类" clearable style="margin-left: 10px; width: 150px;">
          <el-option v-for="cat in categories" :key="cat" :label="cat" :value="cat"></el-option>
        </el-select>
        <el-input v-model="searchKeyword" placeholder="搜索产品名称" clearable style="margin-left: 10px; width: 200px;">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>

      <!-- 产品列表 -->
      <el-table :data="filteredProducts" style="width: 100%; margin-top: 15px;" border>
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="category" label="分类" width="120" />
        <el-table-column prop="name" label="产品名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="spec" label="规格" width="120" />
        <el-table-column prop="price" label="价格" width="80">
          <template slot-scope="scope">
            <span style="color: #f56c6c; font-weight: bold;">¥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="videoUrl" label="视频链接" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.videoUrl" type="success" size="mini">有</el-tag>
            <el-tag v-else type="info" size="mini">无</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="image" label="图片" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.image" type="success" size="mini">有</el-tag>
            <el-tag v-else type="info" size="mini">无</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelete(scope.row)" type="text" size="small" style="color: #f56c6c;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="total-info">
        共 <span>{{ filteredProducts.length }}</span> 款产品
      </div>
    </el-card>

    <!-- 编辑/新增弹窗 -->
    <el-dialog :title="isAdd ? '新增产品' : '编辑产品'" :visible.sync="dialogVisible" width="500px">
      <el-form :model="currentProduct" label-width="80px" size="small">
        <el-form-item label="分类">
          <el-select v-model="currentProduct.category" placeholder="选择分类" allow-create filterable style="width: 100%;">
            <el-option v-for="cat in categories" :key="cat" :label="cat" :value="cat"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="currentProduct.name"></el-input>
        </el-form-item>
        <el-form-item label="规格">
          <el-input v-model="currentProduct.spec"></el-input>
        </el-form-item>
        <el-form-item label="价格">
          <el-input-number v-model="currentProduct.price" :min="0" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="视频链接">
          <el-input v-model="currentProduct.videoUrl" placeholder="留空表示无视频"></el-input>
        </el-form-item>
        <el-form-item label="产品图片">
          <el-upload
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :http-request="handleImageUpload"
            :file-list="fileList"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="currentProduct.remark" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveProduct">确定</el-button>
      </span>
    </el-dialog>

    <!-- 导入JSON弹窗 -->
    <el-dialog title="导入JSON" :visible.sync="importDialogVisible" width="600px">
      <el-input v-model="importJsonText" type="textarea" :rows="15" placeholder="粘贴 fireworks.json 的内容"></el-input>
      <span slot="footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="importJson">导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { uploading } from '@/api/fileApi';
import { saveFireworksJson } from '@/api/pyApi';

export default {
  name: "fireworksAdmin",
  data() {
    return {
      isAuthenticated: false,
      password: '',
      correctPassword: 'gongting',
      shopInfo: {
        name: '',
        description: '',
        address: '',
        phone1: '',
        phone2: ''
      },
      products: [],
      filterCategory: '',
      searchKeyword: '',
      dialogVisible: false,
      isAdd: false,
      currentProduct: {},
      importDialogVisible: false,
      importJsonText: '',
      fileList: []
    };
  },
  computed: {
    categories() {
      return [...new Set(this.products.map(p => p.category))];
    },
    filteredProducts() {
      let result = this.products;
      if (this.filterCategory) {
        result = result.filter(p => p.category === this.filterCategory);
      }
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase();
        result = result.filter(p => p.name.toLowerCase().includes(keyword));
      }
      return result;
    }
  },
  async mounted() {
    // 检查是否已登录
    const authStatus = sessionStorage.getItem('fireworks_auth');
    if (authStatus === 'true') {
      this.isAuthenticated = true;
      await this.loadData();
    }
  },
  methods: {
    verifyPassword() {
      if (this.password === this.correctPassword) {
        this.isAuthenticated = true;
        sessionStorage.setItem('fireworks_auth', 'true');
        this.loadData();
        this.$message.success('登录成功');
      } else {
        this.$message.error('密码错误');
      }
    },
    async loadData() {
      try {
        const response = await axios.get('/json/fireworks.json');
        const data = response.data;
        this.shopInfo = data.shopInfo;
        this.products = data.products;
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },
    handleAdd() {
      this.isAdd = true;
      this.currentProduct = {
        id: this.getNextId(),
        category: '',
        name: '',
        spec: '',
        price: 0,
        videoUrl: '',
        remark: '',
        image: ''
      };
      this.fileList = [];
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.isAdd = false;
      this.currentProduct = { ...row };
      this.fileList = row.image ? [{ url: row.image }] : [];
      this.dialogVisible = true;
    },
    // 图片上传
    handleImageUpload(file) {
      const params = new FormData();
      params.append('image', file.file);
      params.append('token', 'f8c73c2d25794db6f14a1192ff9bc26e');
      uploading(params).then((resp) => {
        this.fileList = [{ url: resp.data.thumb }];
        this.currentProduct.image = resp.data.thumb;
        this.$message.success('上传成功');
      }).catch(() => {
        this.$message.error('上传失败');
      });
    },
    // 图片删除
    handleRemove() {
      this.fileList = [];
      this.currentProduct.image = '';
    },
    // 图片预览
    handlePictureCardPreview(file) {
      window.open(file.url);
    },
    handleDelete(row) {
      this.$confirm(`确认删除产品 "${row.name}" ？`, '提示', {
        type: 'warning'
      }).then(() => {
        const index = this.products.findIndex(p => p.id === row.id);
        if (index > -1) {
          this.products.splice(index, 1);
          this.$message.success('删除成功');
          this.saveToServer();
        }
      }).catch(() => {});
    },
    // 保存到服务器
    async saveToServer() {
      const data = {
        shopInfo: this.shopInfo,
        products: this.products
      };
      try {
        await saveFireworksJson(data);
        this.$message.success('JSON文件已保存');
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.warning('服务器保存失败，请手动导出json文件');
      }
    },
    saveProduct() {
      if (!this.currentProduct.name || !this.currentProduct.category) {
        this.$message.warning('请填写分类和产品名称');
        return;
      }
      if (this.isAdd) {
        this.products.push({ ...this.currentProduct });
        this.$message.success('添加成功');
      } else {
        const index = this.products.findIndex(p => p.id === this.currentProduct.id);
        if (index > -1) {
          this.$set(this.products, index, { ...this.currentProduct });
          this.$message.success('修改成功');
        }
      }
      this.dialogVisible = false;
      this.saveToServer();
    },
    getNextId() {
      if (this.products.length === 0) return 1;
      return Math.max(...this.products.map(p => p.id)) + 1;
    },
    exportJson() {
      const data = {
        shopInfo: this.shopInfo,
        products: this.products
      };
      const jsonStr = JSON.stringify(data, null, 2);
      const blob = new Blob([jsonStr], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'fireworks.json';
      link.click();
      URL.revokeObjectURL(url);
      this.$message.success('导出成功，请将文件替换到 public/json/ 目录下');
    },
    importJson() {
      try {
        const data = JSON.parse(this.importJsonText);
        if (data.shopInfo && data.products) {
          this.shopInfo = data.shopInfo;
          this.products = data.products;
          this.importDialogVisible = false;
          this.importJsonText = '';
          this.$message.success('导入成功');
        } else {
          this.$message.error('JSON格式不正确，需要包含 shopInfo 和 products');
        }
      } catch (e) {
        this.$message.error('JSON解析失败，请检查格式');
      }
    }
  }
};
</script>

<style scoped>
.page-padding {
  padding: 20px;
}
.shop-info-section {
  margin-bottom: 15px;
}
.shop-info-section h3 {
  margin-bottom: 15px;
  color: #303133;
}
.action-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.total-info {
  margin-top: 15px;
  color: #909399;
  font-size: 14px;
}
.total-info span {
  color: #409eff;
  font-weight: bold;
}
/* 密码验证样式 */
.auth-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.auth-card {
  width: 350px;
  text-align: center;
  border-radius: 12px;
}
.auth-card h3 {
  margin: 0 0 10px 0;
  color: #303133;
}
.auth-card p {
  margin: 0 0 20px 0;
  color: #909399;
  font-size: 14px;
}
</style>
